module.exports = __webpack_public_path__ + "img/lasource-26.e781acc8.jpg";